/* Optional game-only 3D layer. The existing paper desk is always the fallback. */
(function () {
  'use strict';
  if (window.InnermonOfficeStage) return;
  window.InnermonOfficeStage = class {
    constructor(root) { this.root = root; this.stage = null; this.pending = null; this.disposed = false; this.ticket = 0; }
    async prepare() {
      if (this.disposed || this.stage || matchMedia('(prefers-reduced-motion: reduce)').matches || new URLSearchParams(location.search).get('desk') === 'paper') return;
      if (this.pending) return this.pending;
      const ticket = ++this.ticket;
      let timeout;
      const create = async () => {
        const module = await import(this.root.dataset.stageModule);
        if (this.disposed || ticket !== this.ticket || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const stage = await module.createStage(this.root);
        if (this.disposed || ticket !== this.ticket) stage.dispose();
        else this.stage = stage;
      };
      this.pending = Promise.race([create(), new Promise((_, reject) => { timeout = setTimeout(() => reject(new Error('Optional stage timeout')), 6000); })])
        .catch(() => { this.ticket += 1; this.root.dataset.stageFallback = '3d-unavailable'; })
        .finally(() => { clearTimeout(timeout); this.pending = null; });
      return this.pending;
    }
    dispose() { this.disposed = true; this.ticket += 1; this.stage?.dispose(); }
  };
})();
